import * as Yup from 'yup';

export default Yup.object().shape({
  investorId: Yup.string().required('SCHEMA_ERRORS.INVESTOR_REQUIRED')
});
